import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

const UserPanel = ({ partsData }) => {
  const cards = [
    { label: "Running hours", value: partsData.total_running_hours || 0, icon: "ri-time-line", color: "text-primary" },
    { label: "Good parts",    value: partsData.good_parts || 0,          icon: "ri-checkbox-circle-line", color: "text-success" },
    { label: "Bad parts",     value: partsData.bad_parts || 0,           icon: "ri-close-circle-line", color: "text-danger" },
    { label: "OEE",           value: partsData.oee || 0,                 icon: "ri-checkbox-circle-line", color: "text-success" },
    { label: "Total parts",   value: partsData.total_parts || 0,         icon: "ri-group-line", color: "text-primary" },
    { label: "Stop hours",    value: partsData.stopped_time || 0,        icon: "ri-time-line", color: "text-primary" },
    // { label: "TEEP",          value: partsData.teep || 0,                icon: "ri-group-line", color: "text-primary" },
  ];

  return (
    <React.Fragment>
      <Row className="g-3 mb-3">
        {cards.map((card, idx) => (
          <Col key={idx} xl={true} sm={6} xs={6}>
            <Card className="h-100 mb-0">
              <CardBody className="p-3">
                <div className="d-flex align-items-center gap-2">
                  <div
                    className={`avatar-title bg-light rounded-circle ${card.color} flex-shrink-0`}
                    style={{ width: 40, height: 40, fontSize: 20, display: "flex", alignItems: "center", justifyContent: "center" }}
                  >
                    <i className={card.icon}></i>
                  </div>
                  <div className="overflow-hidden">
                    <p className="mb-1 text-muted" style={{ fontSize: 12, whiteSpace: "nowrap" }}>
                      {card.label}
                    </p>
                    <h5 className="mb-0">{card.value}</h5>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

export default UserPanel;